import { Button } from "../components/Button";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

export function SetupIntroScreen() {
  const { next } = useFlow();
  const t = useT();

  return (
    <>
      <div className="screen-enter" style={{ flex: 1 }}>
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("setup.eyebrow")}</div>
          <h1 className="screen-head__title">{t("setup.title")}</h1>
          <p className="screen-head__text">{t("setup.text")}</p>
        </header>
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next}>{t("setup.beginSetup")}</Button>
      </div>
    </>
  );
}
